module.exports = __webpack_public_path__ + "static/img/moreDiamonds.c29ab84.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shopImages/moreDiamonds.png
// module id = iL46
// module chunks = 3